"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalDocumentType = void 0;
var ExternalDocumentType;
(function (ExternalDocumentType) {
    ExternalDocumentType[ExternalDocumentType["IDENTITY_PROOF"] = 0] = "IDENTITY_PROOF";
    ExternalDocumentType[ExternalDocumentType["REGISTRATION_PROOF"] = 1] = "REGISTRATION_PROOF";
    ExternalDocumentType[ExternalDocumentType["ARTICLES_OF_ASSOCIATION"] = 2] = "ARTICLES_OF_ASSOCIATION";
    ExternalDocumentType[ExternalDocumentType["SHAREHOLDER_DECLARATION"] = 3] = "SHAREHOLDER_DECLARATION";
    ExternalDocumentType[ExternalDocumentType["ADDRESS_PROOF"] = 4] = "ADDRESS_PROOF";
})(ExternalDocumentType || (exports.ExternalDocumentType = ExternalDocumentType = {}));
//# sourceMappingURL=ExternalDocumentType.js.map